/**
 * @module constants/Middleware
 */

/**
 * The exposed, namespaced User related actions.
 *
 * @note these are subject to change and need clarification
 * @TODO UNUSED: Remove with WEBCA-2899
 */
export const Middleware = Object.freeze({} as const); // UNUSED

export default Middleware;
